import { Product } from 'models/products';
import { ProductSelect } from 'components/filter/input/ProductSelect';
import { useEffect, useState } from 'react';
import { useProductDataService } from 'services/product-data.service';
import { useAppStore } from 'hooks/state/useAppStore';

export function AdvancedProductFilter({
  selectedProductNumbers = undefined,
  setSelectedProductNumbers = undefined,
  placeholder = undefined,
}: {
  selectedProductNumbers?: string[];
  setSelectedProductNumbers?: (value: string[]) => void;
  placeholder?: string;
}) {
  const [selectedProducts, setSelectedProducts] = useState<Product[]>([]);
  const { fetchProductsByNumbers } = useProductDataService();

  const { products, setProducts } = useAppStore();

  const productNumbers = selectedProductNumbers ?? products ?? [];

  useEffect(() => {
    if (!productNumbers?.length) {
      setSelectedProducts([]);
      return;
    }

    (async () => {
      const fetchedProducts = await fetchProductsByNumbers(productNumbers);
      setSelectedProducts(fetchedProducts ?? []);
    })();
  }, [selectedProductNumbers]);

  return (
    <ProductSelect
      selectedProducts={selectedProducts}
      setSelectedProducts={newProducts => {
        setSelectedProducts(newProducts ?? []);
        (setSelectedProductNumbers ?? setProducts)((newProducts ?? []).map(p => p.number));
      }}
      placeholderOverride={placeholder}
    />
  );
}
